@import "../../../styles/base";

// This is the div into which the toaster is portalled
:global(#toaster) {
  position: absolute;
  z-index: 2000;
}

// This is the toaster component itself
.Toaster {
  position: fixed;
  bottom: 2rem;
  width: 0;
}

.toastContainer {
  position: relative;
  height: 100%;
  width: 0;
}

.extraToastContainer {
  position: absolute;
  left: calc(100vw - 34rem);
  width: 32rem;
  bottom: 0;
}

.extraToastContainer:empty {
  display: none;
}

.toast {
  position: absolute;
  transition: all 300ms ease-out;
  left: calc(100vw - 34rem);
  width: 32rem;
}

.toastAlert {
  padding: 1.5rem;
}

.closedToast {
  position: absolute;
  transition: all 300ms ease-in;
  left: calc(100vw - 34rem);
  transform: translateX(25rem);
  opacity: 0;
  width: 32rem;
}

@media screen and (max-width: 36em) {
  .toastContainer,
  .extraToastContainer,
  .toast,
  .closedToast {
    width: calc(100vw - 4rem);
  }

  .extraToastContainer,
  .toast,
  .closedToast {
    left: 2rem;
  }
}

@media screen and (prefers-reduced-motion: reduce) {
  .toast,
  .closedToast {
    transition: none;
  }
}
